import React from 'react'
import Icon from '../../../ui/Icon/Icon'
import './PhoneLinks.sass'
import { useContext } from 'react'
import { AuthContext } from '../../../App'

function PhoneLinks({ useTime = true }) {
  // const { contacts } = useContext(AuthContext)
  return (
    <div className="PhoneLinks">
      <a href={`tel:+38 (068) 000-03-77`} className="PhoneIcon">
        <Icon name="phone" weight="solid" className="AccentIcon" />
      </a>
      <a href="viber://contact?number=%2B380680000377" target="blank">
        <Icon name="viber" weight="brand" />
      </a>
      <a href="https://wa.me/380680000377" target="blank">
        <Icon name="whatsapp" weight="brand" />
      </a>
      <a href="https://t.me/+380680000377" target="blank">
        <Icon name="telegram" weight="brand" />
      </a>
      <div className="Content">
        <a href={`tel:+38 (068) 000-03-77`} className="PhoneNumber">
          +38 (068) 000-03-77
        </a>
        {useTime && <span className="Description">Пн-Пт: 08:00 - 17:00</span>}
      </div>
    </div>
  )
}

export default PhoneLinks
